export enum ArtworkTechnique {
  Acrylic = 'acrylic',
  Collage = 'collage',
  Digital = 'digital',
  Engraving = 'engraving',
  Ink = 'ink',
  Lithography = 'lithography',
  Marker = 'marker',
  MixedMedia = 'mixed-media',
  Mosaic = 'mosaic',
  Oil = 'oil',
  Pencil = 'pencil',
  Photography = 'photography',
  Resin = 'resin',
  ScreenPrint = 'screen-print',
  SprayPaint = 'spray-paint',
  Steel = 'steel',
  Stencil = 'stencil',
  Vinyl = 'vinyl',
  Watercolor = 'watercolor',
  Wood = 'wood',
}